<template>
<div>
    <submission-title
        v-if="!hide_title"
        :form_name="form_submission.instance.form.name"
        :form_status="form_submission.form_status"
    />

    <submission-subtitle
        :form_status="form_submission.form_status"
        :pdf_mode="pdf_mode"
        @open-signature="openSignature(true)"
    />

    <face-fit-certificate-content
        :form_submission="form_submission"
        :pdf_mode="pdf_mode"
    />
</div>
</template>

<script>
import FaceFitCertificateContent from '../people/FaceFitCertificateContent';
import SubmissionTitle from './SubmissionTitle';
import SubmissionSubtitle from './SubmissionSubtitle';
import ShowSignatureModal from '../modals/ShowSignatureModal';

export default {
    components: {
        FaceFitCertificateContent,
        ShowSignatureModal,
        SubmissionTitle,
        SubmissionSubtitle,
    },
    props: {
        form_submission: Object,
        hide_title: Boolean,
        pdf_mode: Boolean,
    },
    methods: {
        openSignature() {
            this.$refs.signature_modal.open();
        },
    },
};
</script>
